import { call, put, takeLatest } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { getTypedContext } from 'ext/lib/saga-context';
import type { Campaign } from 'ext/lib/api/types';
import { FETCH_TACTICS, resolve, reject } from './actions';
import type { TacticGroup } from './types';

/**
 * Fetch the account's campaign → tactic tree in a single request. The
 * `campaigns` query returns each campaign's tactics inline (batched
 * server-side), so there's no per-campaign fan-out.
 */
export function* fetchTactics(): SagaIterator {
  try {
    const api = yield* getTypedContext('api');
    const campaigns: Campaign[] = yield call(api.getCampaigns);

    const groups: TacticGroup[] = campaigns
      .map(campaign => ({
        campaignId: campaign.id,
        campaignName: campaign.name,
        tactics: campaign.tactics,
      }))
      // Drop campaigns with no selectable tactics from the grouped options.
      .filter(group => group.tactics.length > 0);

    yield put(resolve(groups));
  } catch (error) {
    yield put(reject(error as Error));
  }
}

export default function* tacticsSaga(): SagaIterator {
  yield takeLatest(FETCH_TACTICS, fetchTactics);
}
